import { ReactNode } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  back?: ReactNode
  top?: ReactNode
  bottom: ReactNode
  userName?: string
  isTest?: boolean
}

const Navigation = ({ children, back, top, bottom, userName, isTest = false }: Props) => {
  return (
    <>
      <div
        className={clsx(
          'z-base fixed top-14.25 left-0 flex h-[calc(100vh-57px)] max-h-full w-60 flex-col overflow-y-auto',
          'bg-fill-surface-secondary border-secondary rounded-tl-4xl border-r',
          userName ? (back ? '' : 'pt-4 pr-3') : 'pt-10 pr-3'
        )}
      >
        {back && (
          <div className='bg-input-emphasis-active border-fill-caution -z-2 flex items-center border-b py-0.5 pl-4'>
            {back}
          </div>
        )}
        <div className='z-2 flex flex-col'>
          {userName && (
            <div className={'border-secondary mb-2 border-b border-solid pt-2 pb-2'}>
              <div className={clsx('flex items-center gap-2 pl-4', top && 'pb-2')}>
                <div className='flex w-full flex-col gap-1'>
                  {isTest && (
                    <Badge badgeType={BadgeType.SUCCESS} size={10}>
                      テスト環境
                    </Badge>
                  )}
                  <Text size={16} color={TextColor.PRIMARY} lineHeight={150} weight={'bold'}>
                    {userName}
                  </Text>
                </div>
              </div>
              {top && <>{top}</>}
            </div>
          )}
          <ul>{children}</ul>
        </div>
        <ul className='mt-auto py-4'>{bottom}</ul>
      </div>
    </>
  )
}

export default Navigation
